import { TextField } from "@fluentui/react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { ITipoEquipoEdit } from "../../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { UsePanelTipoEquipoEditar } from "./UsePanelTipoEquipoEditar";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";

export interface IPanelTipoEquipoEditar extends IOpenPanel{
    item: ITipoEquipoEdit

}
export const PanelTipoEquipoEditar=(props:IPanelTipoEquipoEditar)=>{
 const {request,setRequest,putEditarTipoEquipo,loading,reset,mensaje,status}= UsePanelTipoEquipoEditar(props)
 const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Editar"
          texto2={"Salir"}
          onClick={putEditarTipoEquipo}
          onDismiss={() => {
             reset()
          }}
        />
      </>
    ),
    [request]
  );
  return (
    <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Editar Tipo Equipo"} 
    status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
      <TextField 
     type="text"
     label="Nombre de Tipo de Equipo"
     placeholder="Ingrese Nombre de Tipo de Equipo"
     autoComplete="off"
     value={request.nombre}
     onChange={(event,newValue)=>{
        if(newValue!=null){
        setRequest({...request,nombre:newValue})}
     }}
     />
     <br/>
    <TextField 
     type="text"
     label="Codigo de Tipo de Equipo"
     placeholder="Ingrese Codigo de Tipo de Equipo"
     autoComplete="off"
     value={request.codigo}
     onChange={(event,newValue)=>{
        if(newValue!=null){
        setRequest({...request,codigo:newValue})}
     }}
     />
     </PanelDrawer>)
}